export default __webpack_public_path__ + "static/grid-types-dark-c5c0c7dc0950c821805b56d8951e5262.png";